// src/pages/AudiologistDashboard.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import backgroundImage from '../assets/TECH-BC.png'; // يمكنك تغييره إذا عندك صورة خاصة
import logo from '../assets/Logo2.png';
import '../App.css';

function AudiologistDashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    localStorage.removeItem('userRole');
    navigate('/');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      {/* الهيدر */}
      <div
        style={{
          backgroundColor: '#0288a9',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.8rem 2rem',
        }}
      >
        <img src={logo} alt="Logo" style={{ height: '45px' }} />
        <h2 style={{ margin: 0, fontWeight: 'bold', letterSpacing: '1px' }}>
          JOB CARD RECORDSYSTEM
        </h2>
        <button
          onClick={handleLogout}
          className="logout-button"
        >
          Sign out
        </button>
      </div>

      {/* المحتوى */}
      <div style={{ textAlign: 'center', marginTop: '5rem' }}>
        <h1 style={{ fontSize: '2.5rem', color: '#006678', fontWeight: '600' }}>
          Welcome Audiologist
        </h1>
        <p style={{ fontSize: '1.2rem', marginTop: '0.5rem', color: '#333' }}>
          You are logged in as audiologist
        </p>

        <div style={{ marginTop: '2rem' }}>
          <button onClick={() => navigate('/create-job-card')} className="dashboard-button">
            Create New Job Card
          </button>
          <button
            onClick={() => navigate('/view-job-cards')}
            className="dashboard-button"
            style={{ marginLeft: '1.5rem' }}
          >
             View All Job Cards
          </button>
          <button
            onClick={() => navigate('/track-status')}
            className="dashboard-button"
            style={{ marginLeft: '1.5rem', backgroundColor: '#0288a9', color: '#ffffffff' }}
          >
             Job Card Tracking
          </button>
        </div>
      </div>
    </div>
  );
}

export default AudiologistDashboard;
